export const APPLICATION_LICENSE_FIXTURES = {
    licenseFile: '',
    systemDateFormat: 'DD YY MM',
    watchlistProvider: 'Dow Jones',
    expiredDate: '31 Mar 2026',
    uploadFileSize: 6,
    applicationId: '31 37 32 2E 31 38 2E 30 2E 31 31 30 32 3A 34 32 3A 41 43 3A 31 32 3A 30 30 3A 30 42 62 30 34 33 62',
    orgName: 'APD Bank'
};
